import { SignupScreen, UserProfile } from 'fitbeat.gym-core';
import React from 'react';
import { translate } from 'react-i18next';
import { Text, View } from 'react-native';
import { connect } from 'react-redux';
import { Gender, StrengthRatioForMuscleGroups } from '../../../models/src';
import { IAppStore } from '../HomeWorkouts';
import theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { getNextStep, navigateToNextStep } from './actions';
import { sharedStyles } from './OnboardingSharedStyles';
import { StrengthLevel } from './StrengthLevel';
import { INavigateToNextStep } from './types';

interface IProps {
  navigation: any;
  userProfileFieldsToUpdateAfterOnboarding: Partial<UserProfile>;
  getNextStep(navigateToNextStep: INavigateToNextStep): void;
  navigateToNextStep(navigateToNextStep: any): void;
  t(key: string, params?: any): string;
}
class StrengthLevelScreenComponent extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  public setLevelAndContinue = (
    strengthRatios: StrengthRatioForMuscleGroups,
  ) => {
    this.props.getNextStep({
      currentScreen: SignupScreen.StrengthLevel,
      userProfile: { strengthRatioForMuscleGroups: strengthRatios },
    });
    this.props.navigateToNextStep(this.props.navigation);
  }

  public render() {
    const { t, userProfileFieldsToUpdateAfterOnboarding } = this.props;
    let { gender } = userProfileFieldsToUpdateAfterOnboarding;

    if (!gender) {
      // this should not happen as the gender question precedes this step
      gender = Gender.Male;
    }
    const title =
      gender === Gender.Other
        ? t('WhatIsYourStrengthLevel')
        : t('WhatIsYourGenderStrengthLevel');
    return (
      <View style={sharedStyles.container}>
        <Text
          style={[theme.textStyle.heading, { marginBottom: defaultScale(6) }]}
        >
          {title}
        </Text>
        <Text
          style={[
            theme.textStyle.bodyCopyReg,
            { color: theme.GREY_MEDIUM, marginBottom: 24 },
          ]}
        >
          {t('personalizeFitnessJourneyStrength')}
        </Text>
        <StrengthLevel
          gender={gender}
          levelSelectionCb={this.setLevelAndContinue}
        />
      </View>
    );
  }
}

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    userProfileFieldsToUpdateAfterOnboarding:
      state.auth.signup.userProfileFieldsToUpdateAfterOnboarding,
  };
};

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export const StrengthLevelScreen = translate(['auth'], { wait: true })(
  connect(mapStateToProps, mapDispatchToProps)(StrengthLevelScreenComponent),
);
